






















































import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator'

@Component
export default class Accordion extends Vue {
  @VModel() private isOpen!: boolean

  @Prop({ type: String, default: 'default' }) type !: 'slim' | 'default'

  @Prop({ type: String, default: 'accordion_open' }) openTitle!: string

  @Prop({ type: String, default: 'accordion_close' }) closeTitle!: string

  @Prop({ type: String, default: 'visible', required: false }) contentOverflow!: 'visible' | 'hidden'

  defaultActiveKey: string | undefined = ''

  visible = false

  @Watch('isOpen', { immediate: true })
  isOpenChange(value: boolean) {
    this.visible = value
  }

  get accordionLabel(): string {
    return this.visible ? this.$t(this.closeTitle).toString() : this.$t(this.openTitle).toString()
  }

  get selectedKey(): string | undefined {
    if (this.visible) {
      return '1'
    }
    return undefined
  }

  set selectedKey(value: string | undefined) {
    if (value) {
      this.defaultActiveKey = value
      this.visible = true
    } else {
      this.defaultActiveKey = undefined
      this.visible = false
    }
  }
}
